// extracted by mini-css-extract-plugin
module.exports = {"body":"Home_body__3bTqO","greeting":"Home_greeting__ZWP_F","App":"Home_App__9wyKe"};